import React, { useState, useEffect } from 'react';
import { Container, Row, Col, InputGroup } from 'react-bootstrap';
import { axiosInstance } from '../../../../../api/axios';
import { HttpSuccessCodes } from '../../../../errorhandling/HttpErrorCodes';
import AddButton from '../../UserFormNew/components/AddButton';
import FilterModal from '../../../../components/common/filter-modal/FilterModal';
import { SearchSVG } from '../../../../img/GlobalSVG';
import TextInput from '../../../../../Components/GenericInputText/TextInput';
import APIEndpoints from '../../../../api/APIEndpoints';
import RetryAPI from '../../../../api/RetryAPI';
import Lists from '../lists';

const BlobPanel = ({
  deleteBlobId,
  onSelectedBlobHandler,
  blobAllData,
  setBlobAllData,
  selectedBlobData,
  unselectMultipleBlobs,
  editAffiliatedRecords,
}) => {
  const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

  const [openBLOBMOdal, setOpenBLOBMOdal] = useState(false);
  const [blobData, setBlobData] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [searched, setSearched] = useState([]);
  const [searchedData, setSearchedData] = useState([]);
  let flag = false;

  const onChangeBLOBHandler = (e) => {
    setSearchString(e.target.value);
    const tempBlob2 = blobData.filter(
      (blob) =>
        blob?.BlkOfBusId?.toLowerCase().includes(
          e.target.value.toLowerCase(),
        ) ||
        blob?.BlkOfBusName?.toLowerCase().includes(
          e.target.value.toLowerCase(),
        ),
    );
    setSearchedData(tempBlob2);
    tempBlob2.map((blob) => {
      if (blob.isChecked === true) {
        return;
      } else {
        flag = true;
      }
    });
    if (!flag) {
      setSearched(tempBlob2);
    } else {
      setSearched([]);
    }
  };
  const handleAddBLOB = () => {
    setOpenBLOBMOdal(true);
  };

  const applyFilterHandler = (e) => {
    const selectedBlob = blobData.filter((blob) => blob.isChecked == true);
    const unSelectedBlob = blobData.filter((blob) => blob.isChecked == false);
    onSelectedBlobHandler(selectedBlob);
    unselectMultipleBlobs(e, unSelectedBlob);
    setOpenBLOBMOdal(false);
    setSearchString('');
    setSearched([]);
  };

  const selectChangeHandler = (e) => {
    const { name, checked } = e.target;
    if (name === 'select-all-blob') {
      if (searchString === '') {
        const tempBlob = blobData.map((blob) => {
          return { ...blob, isChecked: checked };
        });
        setBlobData(tempBlob);
        setBlobAllData(tempBlob);
      } else {
        const tempBlob = blobData.map((blob) =>
          blob?.BlkOfBusId?.toLowerCase().includes(
            searchString.toLowerCase(),
          ) ||
          blob?.BlkOfBusName?.toLowerCase().includes(searchString.toLowerCase())
            ? { ...blob, isChecked: checked }
            : blob,
        );
        const data = tempBlob.filter((blob) => blob.isChecked === true);
        setSearched(data);
        setBlobData(tempBlob);
        setBlobAllData(tempBlob);
      }
    } else {
      if (searchString === '') {
        const tempBlob = blobData.map((blob) =>
          blob.BlkOfBusId === name ? { ...blob, isChecked: checked } : blob,
        );
        setBlobData(tempBlob);
        setBlobAllData(tempBlob);
      } else {
        const tempBlob2 = blobData.map((blob) =>
          blob?.BlkOfBusId?.toLowerCase().includes(
            searchString.toLowerCase(),
          ) ||
          blob?.BlkOfBusName?.toLowerCase().includes(searchString.toLowerCase())
            ? blob.BlkOfBusId === name
              ? { ...blob, isChecked: checked }
              : blob
            : blob,
        );
        const tempBlob = tempBlob2.filter(
          (blob) =>
            blob?.BlkOfBusId?.toLowerCase().includes(
              searchString.toLowerCase(),
            ) ||
            blob?.BlkOfBusName?.toLowerCase().includes(
              searchString.toLowerCase(),
            ),
        );
        //const tempBlob1 = tempBlob.map( blob => blob.BlkOfBusId === name ? { ...blob, isChecked: checked } : blob );
        tempBlob.map((blob) => {
          if (blob.isChecked === true) {
            return;
          } else {
            flag = true;
          }
        });
        if (!flag) {
          setSearched(tempBlob);
        } else {
          setSearched([]);
        }
        setBlobData(tempBlob2);
        setBlobAllData(tempBlob2);
      }
    }
  };

  const getBlobData = async () => {
    try {
      const BlobListResponse = await axiosInstance.get(
        cacheBuster(APIEndpoints.getBLOBListResources() + 'pagesize/5000'),
      );
      if (BlobListResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        console.log(
          'BlobListResponse :::: $$$$$ ::::: ',
          BlobListResponse.data.Response.BlockOfBusiness,
        );
        //setBlobData(tempBlob);
        if (BlobListResponse?.data?.Response?.BlockOfBusiness) {
          if (selectedBlobData && selectedBlobData.length > 0) {
            const blobList = BlobListResponse?.data?.Response?.BlockOfBusiness;
            const tempObj = blobList.map((item) =>
              selectedBlobData.filter((selectedItem) =>
                Boolean(selectedItem.BlkOfBusId === item.BlkOfBusId),
              ).length
                ? { ...item, isChecked: true }
                : item,
            );
            setBlobData(tempObj);
            setBlobAllData(tempObj);
          } else {
            setBlobData(BlobListResponse?.data?.Response?.BlockOfBusiness);
            setBlobAllData(BlobListResponse?.data?.Response?.BlockOfBusiness);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (deleteBlobId) {
      const tempBlobData = blobData.map((blob) =>
        blob.BlkOfBusId === deleteBlobId ? { ...blob, isChecked: false } : blob,
      );
      const checkedBlobData = tempBlobData.filter(
        (blob) => blob.isChecked == true,
      );
      onSelectedBlobHandler(checkedBlobData);
      setBlobData(tempBlobData);
      setBlobAllData(tempBlobData);
    } else {
      blobAllData && blobAllData.length > 0
        ? selectedBlobData && selectedBlobData.length > 0
          ? setBlobAllData(
              blobAllData.map((item) =>
                selectedBlobData.filter((selectedItem) =>
                  Boolean(selectedItem.BlkOfBusId === item.BlkOfBusId),
                ).length
                  ? { ...item, isChecked: true }
                  : item,
              ),
            )
          : setBlobData(blobAllData)
        : getBlobData();
    }
  }, [deleteBlobId, selectedBlobData]);

  return (
    <>
      {editAffiliatedRecords ? (
        <AddButton
          onClick={() => handleAddBLOB()}
          className={'add-button-active'}
        />
      ) : (
        <AddButton className={'add-button-disable'} />
      )}
      <FilterModal
        showBackButton={false}
        isVisible={openBLOBMOdal}
        onHide={() => {
          setSearchString('');
          setOpenBLOBMOdal(false);
        }}
        applyFilterHandler={applyFilterHandler}
        showCancel={true}
        titleLabel="Block of Business(es)"
        showApply={true}
        showApplyLabel="Add Selected"
      >
        {blobData && Object.keys(blobData).length ? (
          <Container className="mt-3 mb-3">
            <Row>
              <Col sm={12}>
                <div>
                  <TextInput
                    parentClassName="mb-2"
                    label="Block of Business"
                    append={
                      <InputGroup.Text>
                        <SearchSVG.SearchSVG className="primary-text-color" />
                      </InputGroup.Text>
                    }
                    inputProps={{
                      type: 'text',
                      placeholder: 'Search by name or BLOB ID',
                      value: searchString,
                      onChange: onChangeBLOBHandler,
                      className: 'border-right-0',
                      autoFocus: false,
                      id: 'filter-broker-input',
                    }}
                  />
                </div>
              </Col>
            </Row>
            {searchString === '' ? (
              <>
                {
                  <>
                    <Row>
                      <Col sm={12} className="mt-4 mb-2">
                        <div className=" select-all-row d-flex">
                          <input
                            type="checkbox"
                            id="select-all-blob"
                            name="select-all-blob"
                            className="p-0 mt-auto mb-auto"
                            onChange={(e) => {
                              selectChangeHandler(e);
                            }}
                            checked={
                              searchString === ''
                                ? blobAllData && blobAllData.length > 0
                                  ? blobAllData.filter(
                                      (blob) => blob.isChecked !== true,
                                    ).length < 1
                                  : blobData.filter(
                                      (blob) => blob.isChecked !== true,
                                    ).length < 1
                                : searched && searched.length > 0
                                ? searched.filter(
                                    (blob) => blob.isChecked !== true,
                                  ).length < 1
                                : blobData.filter(
                                    (blob) => blob.isChecked !== true,
                                  ).length < 1
                            }
                          />
                          <label
                            className="my-auto select-all-checkbox"
                            htmlFor="select-all-blob"
                          >
                            Select All
                          </label>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} className="mb-1">
                        <Lists
                          data={
                            blobAllData && blobAllData.length > 0
                              ? blobAllData
                              : blobData
                          }
                          selectChangeHandler={selectChangeHandler}
                          displayId="BlkOfBusId"
                          displayLabel="BlkOfBusName"
                          labelIdText="BLOB ID"
                          searchString={searchString}
                        />
                      </Col>
                    </Row>
                  </>
                }
              </>
            ) : (
              <>
                {searchedData && Object.keys(searchedData).length ? (
                  <>
                    <Row>
                      <Col sm={12} className="mt-4 mb-2">
                        <div className=" select-all-row d-flex">
                          <input
                            type="checkbox"
                            id="select-all-blob"
                            name="select-all-blob"
                            className="p-0 mt-auto mb-auto"
                            onChange={(e) => {
                              selectChangeHandler(e);
                            }}
                            checked={
                              searchString === ''
                                ? blobAllData && blobAllData.length > 0
                                  ? blobAllData.filter(
                                      (blob) => blob.isChecked !== true,
                                    ).length < 1
                                  : blobData.filter(
                                      (blob) => blob.isChecked !== true,
                                    ).length < 1
                                : searched && searched.length > 0
                                ? searched.filter(
                                    (blob) => blob.isChecked !== true,
                                  ).length < 1
                                : blobData.filter(
                                    (blob) => blob.isChecked !== true,
                                  ).length < 1
                            }
                          />
                          <label
                            className="my-auto select-all-checkbox"
                            htmlFor="select-all-blob"
                          >
                            Select All
                          </label>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} className="mb-1">
                        <Lists
                          data={
                            blobAllData && blobAllData.length > 0
                              ? blobAllData
                              : blobData
                          }
                          selectChangeHandler={selectChangeHandler}
                          displayId="BlkOfBusId"
                          displayLabel="BlkOfBusName"
                          labelIdText="BLOB ID"
                          searchString={searchString}
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  <Container className="mt-3 mb-3">
                    <div>No Records Found</div>
                  </Container>
                )}
              </>
            )}
          </Container>
        ) : (
          <Container className="mt-3 mb-3">
            <div>No Records Found</div>
          </Container>
        )}
      </FilterModal>
    </>
  );
};

export default BlobPanel;
